import { useMemo } from "react";

export default function useURLSearchParams() {
  return useMemo(
    () => new URLSearchParams(decodeURI(window.location.search)),
    []
  );
}
